import { render, staticRenderFns } from "./PaTabbedMenu.vue?vue&type=template&id=76d16d53&"
import script from "./PaTabbedMenu.vue?vue&type=script&lang=js&"
export * from "./PaTabbedMenu.vue?vue&type=script&lang=js&"
import style0 from "./PaTabbedMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports